import { create } from 'zustand';
import { IWeekSchedule, IWeekScheduleDetailed, IWeekScheduleGrouped } from '../model/weekSchedule';

interface IWeekScheduleState {
    weekSchedule: IWeekSchedule | null;
    weekScheduleGrouped: IWeekScheduleGrouped | null;
    weekScheduleDetailed: IWeekScheduleDetailed | null;
    setWeekSchedule: (weekSchedule: IWeekSchedule | null) => void;
    setWeekScheduleGrouped: (weekScheduleGrouped: IWeekScheduleGrouped | null) => void;
    setWeekScheduleDetailed: (weekScheduleDetailed: IWeekScheduleDetailed | null) => void;
}

export const useWeekScheduleStore = create<IWeekScheduleState>((set) => ({
    weekSchedule: null, 
    weekScheduleGrouped: null,
    weekScheduleDetailed: null,
    setWeekSchedule: (weekSchedule: IWeekSchedule | null) => set({ weekSchedule }),
    setWeekScheduleGrouped: (weekScheduleGrouped: IWeekScheduleGrouped | null) => set({ weekScheduleGrouped }),
    setWeekScheduleDetailed: (weekScheduleDetailed: IWeekScheduleDetailed | null) => set({ weekScheduleDetailed }),
}));
